import { toSignal } from '@angular/core/rxjs-interop';
import { computed, inject, Signal } from '@angular/core';
import { OrderQuery } from './state/order.query';
import { Tag } from '@models/tag';

export function hasOrderStateTag(key: Tag): Signal<boolean> {
    const tags = toSignal(inject(OrderQuery).tags$);
    return computed(() => !!tags().get(key));
}

export function getOrderStateTag(key: Tag): Signal<unknown> {
    const tags = toSignal(inject(OrderQuery).tags$);
    return computed(() => tags().get(key));
}
